import {Component, Vue, Watch} from "vue-property-decorator";
import {customSort} from "@/utils/data-helper";
import { cloneDeep } from "lodash";

@Component
export default class BaseItemsPage<T extends object> extends Vue {
  protected tableFields:string[] = [];
  protected currentSort:string = "id";
  protected currentSortOrder:string = "desc";
  protected currentSortPrev:string = '';
  protected currentSortOrderPrev:string = '';

  filterClone: any = {};
  runFilter: boolean = false;

  getData():any {
    return [];
  }

  tableFieldsName():string {
    return `${this.$options.name || ''}TableFields`;
  };

  get tableFieldsActive(){
    if (localStorage.getItem(this.tableFieldsName())){
      let saveData = JSON.parse(localStorage.getItem(this.tableFieldsName()) || '');
      if (saveData) {
        this.tableFields = saveData;
        return saveData
      }
    }
    return this.tableFields;
  };

  @Watch('tableFields')
  getValue(val:string){
    localStorage.setItem(this.tableFieldsName(), JSON.stringify(val))
  }

  get tableData(): T[] {
    this.filterClone['order_by'] = this.currentSort;
    this.filterClone['order_direction'] = this.currentSortOrder;
    this.currentSortPrev = this.currentSort
    this.currentSortOrderPrev = this.currentSortOrder
    return this.getData() ?? [];
  }

  get queriedData():T[] {
    return customSort<T>(this.currentSort, this.currentSortOrder, cloneDeep(this.tableData));
  }

  customSort(value:any):any {
    return customSort<T>(this.currentSort, this.currentSortOrder, value);
  }

  filterSort(value:any) {
    if (this.currentSort == this.currentSortPrev && this.currentSortOrder == this.currentSortOrderPrev) return
    this.runFilter = true;
  }

  setFilter(field: string, value: any) {
    this.filterClone[field] = value;
    this.runFilter = true;
  }

  itemColor(item:any) {
    if (item.delivered / item.total * 100 < 50) return 'color-danger';
    if (item.delivered / item.total * 100 < 85) return 'color-warning';
    if (item.delivered / item.total * 100 < 100) return 'color-success';
    return 'color-success'
  }
}
